import React, { useState } from "react";
import "./style.css";
import { VscGrabber, VscClose } from "react-icons/vsc";
import { Link } from "react-router-dom";
import { followLink, logotext, socialprofils } from "../content_option";
import Themetoggle from "../components/themetoggle";
import { FaInstagram, FaMapMarkerAlt } from "react-icons/fa";

const Headermain = (props) => {
  const [isActive, setActive] = useState("false");

  const handleToggle = () => {
    setActive(!isActive);
    document.body.classList.toggle("ovhidden");
  };

  const onLinkClick = (tab) => {
    handleToggle()
    props.onClick && props.onClick(tab)
  }

  return (
    <>
      <header className="fixed-top site__header">
        <div className="d-flex align-items-center justify-content-between">
          <Link className="navbar-brand nav_ac" to="/">
            {logotext}
          </Link>
          <div className="d-flex align-items-center">
            <Themetoggle />
            <button className="menu__button  nav_ac" onClick={handleToggle}>
              {!isActive ? <VscClose /> : <VscGrabber />}
            </button>

          </div>
        </div>

        <div className={`site__navigation ${!isActive ? "menu__opend" : ""}`}>
          <div className="bg__menu h-100">
            <div className="menu__wrapper">
              <div className="menu__container p-3">
                <ul className="the_menu">
                  <li className="menu_item">
                    <button onClick={() => onLinkClick(1)} className="my-3">Home</button>
                    <div className="invisible-border"></div>
                  </li>
                  <li className="menu_item">
                    <button href=' ' onClick={() => onLinkClick(2)} className="my-3">Portfolio</button>
                    <div className="invisible-border"></div>
                  </li>
                  <li className="menu_item">
                    <button href=' ' onClick={() => onLinkClick(3)} className="my-3">Über uns</button>
                    <div className="invisible-border"></div>
                  </li>
                  <li className="menu_item">
                    <button href=' ' onClick={() => onLinkClick(4)} className="my-3">Impressum</button>
                    <div className="invisible-border"></div>
                  </li>
                </ul>
              </div>
              <div className="menu_footer d-flex flex-column flex-md-row justify-content-between align-items-md-center position-absolute w-100 p-3">
                <div className="d-flex">
                  <div style={{ display: 'flex', paddingLeft: '5px' }}>
                    <a style={{ paddingTop: '2px' }} href="https://maps.app.goo.gl/eEiraQvxaq2bThJG6">
                      <FaMapMarkerAlt size={24} />
                    </a>
                    <div>
                      31157 Sarstedt    | Inge- Meysel- Str. 31<br />
                      info@pb-richard.de | www.pb-richard.de<br />
                      telefon 05066 - 92 796 42<br /><br />
					  copyright _____ Planungsbüro Richard
                    </div>

                  </div>
                </div>

                <div className="stick_follow_icon">
                  <ul>
                    {socialprofils.instagram && (
                      <li>
                        <a href={socialprofils.instagram} target='_blank' rel="noreferrer">
                          <FaInstagram />
                        </a>
                      </li>
                    )}
                  </ul>
                  <p>{followLink.text}</p>
                </div>

              </div>
            </div>
          </div>

        </div>
      </header>
      <div className="br-top"></div>
      <div className="br-bottom"></div>
      <div className="br-left"></div>
      <div className="br-right"></div>

    </>
  );
};

export default Headermain;

